export enum DeviceTab {
	Overview = 'tab-overview',
	Contacts = 'tab-contacts',
	FacilitiesDevices = 'tab-facilities-devices'
}
